import { apiClient, handleRequest } from '@/shared/api';
import type {
  SendMfaOtpCodeRequestDto,
  SendMfaOtpCodeResponseDto,
  VerifyMfaOtpCodeRequestDto,
} from './types';

export const sendTwoFactorIdentityCode = async (
  args: SendMfaOtpCodeRequestDto
) => {
  const request = () => apiClient.post(`/security/otp/send`, args);
  const response = await handleRequest<SendMfaOtpCodeResponseDto>(request);
  return response.data;
};

export const verifyTwoFactorIdentityCode = async (
  args: VerifyMfaOtpCodeRequestDto
) => {
  const request = () => apiClient.post(`/security/otp/contact/verify`, args);
  const response = await handleRequest(request);
  return response.data;
};
